let orgs =[
  { name: 'Delfos Energy', link:'https://www.linkedin.com/company/delfos-energy-brasil/', occupation: 'Data Engineer - engineering data and developing AI solutions on an international scale.'},
    { name: 'Techify', link:'https://www.linkedin.com/company/techifybrasil/', occupation: 'AI Engineer - building AI and Automation solutions  on a national scale.'},
    { name: 'PekiCode', link:'https://www.linkedin.com/company/peki-code/', occupation: 'Project Director - leading the development team and ensuring the delivery of high‑quality projects, bridging higher-education talent to the regional job market.'},
    { name: 'TopNet', link:'https://www.facebook.com/topnetprovedordeinternet/?locale=pt_BR', occupation: 'Technical Support - handling customer tickets and configuring routers.'},
  ];

export default orgs;

